// PanelMasivaOptimizacion — P3-9b (remate de presentación). PRESENTACIONAL: recibe el
// estado del hook `useMasivaOptimizacion` y muestra la franja grande SOLO cuando hay
// algo que mostrar (confirmación, trabajo en curso/pausado, o recién terminado hasta
// que se cierra). El DISPARADOR ya NO vive acá — es un botón del encabezado. Cuando no
// hay trabajo, no ocupa el encabezado: no renderiza nada.
import React from 'react';
import Button from './ui/Button';
import { pesoLegible } from '../utils/fotosOptimizar';

export default function PanelMasivaOptimizacion({ masiva, hasFilters = false }) {
  if (!masiva || !masiva.visiblePanel) return null;
  const { trabajo, confirmando, ocupado } = masiva;

  if (confirmando) {
    return (
      <div className="masiva-panel" role="alert">
        <span>Se optimizarán <strong>{confirmando.fotos}</strong> foto(s) de <strong>{confirmando.productos}</strong> producto(s){hasFilters ? ' (los del filtro actual)' : ' (todo el catálogo)'}. Las que ya están óptimas se saltan; se completan los textos alternativos vacíos.</span>
        <div className="masiva-panel-acc">
          <Button size="sm" onClick={masiva.cancelarConfirmacion} disabled={ocupado}>Cancelar</Button>
          <Button size="sm" variant="primary" onClick={masiva.iniciar} disabled={ocupado}>Iniciar optimización</Button>
        </div>
      </div>
    );
  }

  if (masiva.activo) {
    const procesadas = (trabajo.hechas || 0) + (trabajo.omitidas || 0) + (trabajo.errores || 0);
    const pct = trabajo.total ? Math.round((procesadas / trabajo.total) * 100) : 0;
    return (
      <div className="masiva-panel" role="status">
        <div className="masiva-panel-top">
          <strong>Optimización masiva · {trabajo.estado === 'pausado' ? 'pausada' : 'en curso'}</strong>
          <span>{procesadas}/{trabajo.total} ({pct}%) · {trabajo.hechas} optimizadas · {trabajo.omitidas} ya óptimas · {pesoLegible(trabajo.ahorroBytes)} ahorrados{trabajo.errores ? ` · ${trabajo.errores} con error` : ''}</span>
        </div>
        <div className="masiva-panel-bar"><div className="masiva-panel-bar-fill" style={{ width: `${pct}%` }} /></div>
        <div className="masiva-panel-acc">
          {trabajo.estado === 'corriendo'
            ? <Button size="sm" onClick={() => masiva.pausarReanudar('pausar')} disabled={ocupado}>Pausar</Button>
            : <Button size="sm" onClick={() => masiva.pausarReanudar('reanudar')} disabled={ocupado}>Reanudar</Button>}
        </div>
      </div>
    );
  }

  // terminado (visto correr en esta sesión, sin cerrar): resumen + cerrar.
  return (
    <div className="masiva-panel masiva-panel--fin" role="status">
      <div className="masiva-panel-top">
        <strong>Optimización masiva terminada</strong>
        <span>{trabajo.hechas} optimizadas · {trabajo.omitidas} ya óptimas · {pesoLegible(trabajo.ahorroBytes)} ahorrados{trabajo.errores ? ` · ${trabajo.errores} con error` : ''}</span>
      </div>
      <div className="masiva-panel-acc">
        <Button size="sm" onClick={masiva.cerrar}>Cerrar</Button>
      </div>
    </div>
  );
}
